<template>
	<!-- <f7-page class=""> -->
  <div class="page">
    <bottom-toolbar></bottom-toolbar>
    <div class="page-content">


  		<div class="layoutTop"/>

      <!-- TODO -->
      <f7-list form>
        <li>
          <a href="#" class="item-content">
            <div class="item-inner">
              <div class="item-title-row">
                <div class="item-title">Group name</div>
              </div>
              <div class="item-after">{{ memberGroupLabel }}</div>
            </div>
          </a>
        </li>
        <li>
          <a href="#" class="item-content">
            <div class="item-inner">
              <div class="item-title-row">
                <div class="item-title">Service {{ service }}</div>
              </div>
              <div class="item-after">{{ actif }}</div>
            </div>
          </a>
        </li>
      </f7-list>

      <div class="contactGroupTitle" v-if="1">Members in this group</div>
      <f7-list v-if="1">
        <f7-list-item v-for="value in this.membersArray" v-bind:key="value.id" v-bind:title="value.login"></f7-list-item>
      </f7-list>
      <!-- TODO -->

  		<f7-button round
      href="/accountMembers/editMemberGroup/"
      class="orangeConfirmationButton firstButtonMarginTop">
        Edit member group
      </f7-button>
      <f7-button round
      class="orangeConfirmationButton"
      @click="removeMemberGroup">
        Delete
      </f7-button>
      <div class="toolbarPageBottomBlank"></div>
    </div>
  </div>
	<!-- </f7-page> -->
</template>

<script>
import pageNavBar from '@/components/common/pageNavBar.vue'
import {errorMessageAlert} from '@/helpers/alert'
import bottomToolbar from '@/components/bottomToolbar/bottomToolbar.vue'
import {loadPage} from '@/helpers/routing'

export default {
  components: {
    'page-nav-bar': pageNavBar,
    'bottom-toolbar': bottomToolbar
  },
  data: () => {
    return {
      memberGroupId: '',
      memberGroupLabel: '',
      memberIdArray: [],
      membersArray: [],
      service: '',
      actif: 0
    }
  },
  created () {
    this.memberGroupId = this.$settings.currentMemberGroup.id
    this.memberGroupLabel = this.$settings.currentMemberGroup.label
    this.memberIdArray = this.$settings.currentMemberGroup.members
    this.service = this.$engine.user.currentService.name
    this.actif = (this.$settings.currentMemberGroup.actif === '1' ? 'Activate' : 'Deactivate')
    for (let i = 0; i < this.$settings.currentAccount.userAccts.length; i++) {
      if (this.memberIdArray.includes(this.$settings.currentAccount.userAccts[i].id) && this.$engine.user.currentService.id === this.$settings.currentMemberGroup.id_service) {
        this.membersArray.push(this.$settings.currentAccount.userAccts[i])
      }
    }
  },
  beforeDestroy () {
  },
  destroyed () {
  },
  methods: {
    removeMemberGroup () {
      let that = this
      that.$f7.confirm('Are you sure to delete this group?', 'Operation confirmation', function () {
        that.$engine.accounts
        .deleteGroup(that.memberGroupId)
        .then(resp => {
          that.$f7.modal({
            title: 'Member group deleted',
            text: '<span class="preloader"></span>'
          })
          setTimeout(function () {
            that.memberGroupId = ''
            that.memberGroupLabel = ''
            that.memberIdArray = []
            that.membersArray = []
            that.$f7.closeModal()
            that.$bus.$emit('refresh-cache-account-members')
            loadPage(that, {url: '/accountMembers/', force: false, ignoreCache: false})
          }, 2000)
        })
        .catch(err => {
          errorMessageAlert(err, that)
        })
      })
    },
    getServiceColor (service) {
      switch (service) {
        case 'Direct Debit':
          return '#572B74'
        case 'Direct Payments':
          return '#12BCF1'
        default: // Payments
          return '#51A45C'
      }
    }
  }
}
</script>
